<div class="pdpm-modal">

  <!-- Header -->
  <div class="header">
    <div class="title-section">
      <div class="title">PDPM Rate Summary</div>
      <div class="subtitle">Patient-Driven Payment Model</div>
    </div>

    <button mat-icon-button (click)="closePopUp()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Top Cards -->
  <div class="summary-cards">

    <div class="summary-card">
      <div class="label">FINAL DAILY RATE</div>
      <div class="blue-value">
        {{ finalDailyPatientRate }}
      </div>
    </div>

    <div class="summary-card">
      <div class="label">30-DAY PROJECTION</div>
      <div class="green-value">
        {{ projection30Day }}
      </div>
    </div>

    <div class="summary-card">
      <div class="label">100-DAY PROJECTION</div>
      <div class="green-value">
        {{ projection100Day }}
      </div>
    </div>

  </div>

  <!-- Middle Section -->
  <div class="middle-section">

    <!-- Rate Breakdown -->
    <div class="card">

      <div class="card-header blue-header">
        📋 Rate Breakdown
      </div>

      <div class="row">
        <span>Wage-adjusted base</span>
        <span>{{ wageAdjustedBase }}</span>
      </div>

      <div class="row">
        <span>Total NTA add-on</span>
        <span>{{ totalNTAAddOn }}</span>
      </div>

      <div class="row">
        <span>PDPM total</span>
        <span>{{ pdpmTotal }}</span>
      </div>

      <div class="row">
        <span>Combined rate</span>
        <span>{{ combinedRate }}</span>
      </div>

      <div class="row">
        <span>After adjustments</span>
        <span>{{ afterAdjustments }}</span>
      </div>

    </div>

    <!-- Urban vs Rural -->
    <div class="card">

      <div class="card-header green-header">
        ✓ Urban vs. Rural
      </div>

      <div class="row">
        <span>Urban daily rate</span>
        <span>{{ urbanDailyRate }}</span>
      </div>

      <div class="row">
        <span>Rural daily rate</span>
        <span>{{ ruralDailyRate }}</span>
      </div>

      <div class="row">
        <span>Rural add-on</span>
        <span>{{ ruralAddOn }}</span>
      </div>

      <div class="row">
        <span>Difference</span>
        <span class="difference">
          {{ difference }}
        </span>
      </div>

      <div class="row">
        <span>Total daily rate</span>
        <span>{{ totalDailyRate }}</span>
      </div>

    </div>

  </div>

  <!-- Projection Table -->
  <div class="projection-card">

    <div class="projection-header">
      📂 Projections
    </div>

    <table>

      <thead>
        <tr>
          <th>Period</th>
          <th>Projected Total</th>
          <th>Daily Rate</th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td>📅 30-day stay</td>
          <td class="green-text">
            {{ projection30Day }}
          </td>
          <td>
            {{ totalDailyRate }}/day
          </td>
        </tr>

        <tr>
          <td>📅 100-day stay</td>
          <td class="green-text">
            {{ projection100Day }}
          </td>
          <td>
            {{ totalDailyRate }}/day
          </td>
        </tr>

      </tbody>

    </table>

  </div>

 
</div>